<template>
  <!--  v-on:click="checkModule" -->
  <div class="com-item" :key="index" id="a_8899">
    <div class="component person-nav">
      <div class="van-sticky" :style="{backgroundColor: modata.WContent.bgColor || 'transparent', }">
        <div class="hotarea-pic-container" v-if="modata.WContent.imgInfo">
          <img ref="hotImage" :src="modata.WContent.imgInfo.url"  @load="getImageWidth" />
          <div
            class="linkbox"
            v-for="(item,index) in modata.WContent.nav"
            :key="index"
            :style="{top:item.y1+'px',left:item.x1+'px',width:item.width+'px',height:item.height+'px',zIndex:(item.number||8)}"
            @click="pageNavigate(item.linkUrl)"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "hotpot-module",
  components: {},
  props: {
    index: {
      //索引
      type: Number
    },
    phoneWidth: {
      type: Number,
      default: 1280,
    },
    proportion: {
        type: Number,
        default:1,
    },
    modata: {
            type: Object,
      }
  },
  data() {
    return {};
  },
  mounted() {
console.log(this.modata.WContent)

  },
  beforeDestroy() {},
  methods: {
    getImageWidth(){
      let nav=this.modata.WContent.nav;
      let imageWidth= this.$refs.hotImage.offsetWidth;
      let ratio=imageWidth/750
      nav.forEach(item=>{
        item.y1= item.y1*ratio;
        item.x1= item.x1*ratio;
        item.width= item.width*ratio;
        item.height= item.height*ratio;
      })
      //width: 236px; height: 284px; top: 229px; left: 73px; pointer-events: auto;
    },
    pageNavigate(path){
      if(!path){
        return
      }
      if(/^(https?:|mailto:|tel:)/.test(path)){
       window.open(path)
      }else{
        this.$router.push(path)
      }
    },


  },
  watch: {},
  filters: {
    setStyle(obj) {
      return {
        color: obj.color || "#333",
        fontSize: (obj.size || "14") + "px",
        zIndex: obj.number || 8,
      };
    },
  },
};
</script>
<style scoped>
.hotarea-pic-container {
  position: relative;
  max-width: 1600px;
  margin: auto;
  width: 96%;
}
.hotarea-pic-container img {
  width: 100%;
  display: block;
}
.linkbox {
  position: absolute;
}
</style>
